import script from "./FlyschBizkaiaView.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyschBizkaiaView.vue?vue&type=script&setup=true&lang=js"

import "./FlyschBizkaiaView.vue?vue&type=style&index=0&id=43c02d80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c02d80"]])

export default __exports__